import TalentPool from './TalentPool';

export default TalentPool;